$(function () {

    $('#workpositionworkercompetence-worker_competence_id').change(function (e) {
        e.preventDefault();
        var selected_type = $("#workpositionworkercompetence-worker_competence_id option:selected").data("type");
        var scale_from = $("#workpositionworkercompetence-worker_competence_id option:selected").data("scale_from");
        var scale_to = $("#workpositionworkercompetence-worker_competence_id option:selected").data("scale_to");
        if (selected_type === "scale") {
            $('#workpositionworkercompetence-required_scale').empty();
                //.find('option')
                //.remove()
                //.end();
            for (let i = scale_from; i <= scale_to; i++) {
                $('#workpositionworkercompetence-required_scale').append('<option value="'+i+'">'+i+'</option>').val(i);
            }
            $("#scale-field").show();
        } else {
            $("#scale-field").hide();
        }
    });

});